import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

const TRANSITION_DURATION = 200

// Connects to data-controller="toast" on individual toast elements
export default class extends Controller {
  #isDisposed = false

  connect() {
    this.#isDisposed = false
    this.#initializeToast()
  }

  disconnect() {
    if (this.#isDisposed) return
    this.#isDisposed = true

    this.element.removeEventListener("hidden.bs.toast", this.#hiddenListener)

    if (this.toast) {
      this.toast.dispose()
      this.toast = null
    }
  }

  #initializeToast() {
    // Disable Bootstrap animation - we use CSS transitions instead
    this.toast = new Toast(this.element, {
      autohide: true,
      delay: 5000,
      animation: false
    })

    this.toast.show()

    // Trigger CSS fade-in on next frame
    requestAnimationFrame(() => {
      if (!this.#isDisposed) {
        this.element.classList.add("toast-visible")
      }
    })

    this.element.addEventListener("hidden.bs.toast", this.#hiddenListener)
  }

  #hiddenListener = () => {
    if (this.#isDisposed) return
    this.#isDisposed = true

    this.element.removeEventListener("hidden.bs.toast", this.#hiddenListener)

    // Start CSS fade-out
    this.element.classList.remove("toast-visible")
    this.element.classList.add("toast-hiding")

    // Wait for transition, then cleanup
    setTimeout(() => {
      if (this.toast) {
        this.toast.dispose()
        this.toast = null
      }
      this.element.remove()
    }, TRANSITION_DURATION)
  }
}
